/**
* 评分面板组件
* 显示评分结果和详细分析
*
* @component ScorePanel
* @props {Object} scores - 评分数据对象，包含各项评分指标和维度
*/

<template>
  <div class="score-section">
    <div class="tabs">
      <div
          v-for="(tab, index) in tabs"
          :key="index"
          :class="['tab', { active: activeTab === index }]"
          :title="tab.name"
          @click="activeTab = index"
      >
        {{ tab.name }}
      </div>
    </div>
    <div class="tab-content">
      <template v-if="hasScores">
        <div v-if="activeTab === 0">
          <TypewriterText
            v-if="scores.overall?.comments"
            :activeTab="activeTab"
            :currentStep="currentStep"
            :isView="isView"
            :text="scores.overall.comments"
            :speed="40"
          />
          <ScoreEchart
              v-if="scores.overall?.scores"
              :isView="isView"
              :value="scores.overall.scores"
              :indicator="scores.overall.dimensions"
              :maxScores="scores.overall.max_scores"
          />
        </div>

        <div v-if="activeTab === 1">
          <TypewriterText
              :activeTab="activeTab"
              :currentStep="currentStep"
              v-if="scores.background?.comments"
              :isView="isView"
              :text="scores.background.comments"
              :speed="40"
          />
          <ScoreEchart
              v-if="scores.background?.scores"
              :isView="isView"
              :value="scores.background.scores"
              :indicator="scores.background.dimensions"
              :maxScores="scores.background.max_scores"
          />
        </div>

        <div v-if="activeTab === 2">
          <TypewriterText
              v-if="scores.solution?.comments"
              :currentStep="currentStep"
              :activeTab="activeTab"
              :isView="isView"
              :text="scores.solution.comments"
              :speed="40"
          />
          <ScoreEchart
              v-if="scores.solution?.scores"
              :isView="isView"
              :value="scores.solution.scores"
              :indicator="scores.solution.dimensions"
              :maxScores="scores.solution.max_scores"
          />
        </div>

        <div v-if="activeTab === 3">
          <TypewriterText
              v-if="scores.effect?.comments"
              :currentStep="currentStep"
              :activeTab="activeTab"
              :isView="isView"
              :text="scores.effect.comments"
              :speed="40"
          />
          <ScoreEchart
              v-if="scores.effect?.scores"
              :isView="isView"
              :value="scores.effect.scores"
              :indicator="scores.effect.dimensions"
              :maxScores="scores.effect.max_scores"
          />
        </div>
      </template>
      <div v-else-if="!isView" class="loading-container">
        <el-icon class="loading-icon"><Loading /></el-icon>
        <span>评分分析中...</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { Loading } from '@element-plus/icons-vue'
import TypewriterText from '@/components/TypewriterText.vue'
import ScoreEchart from '@/components/score/ScoreEchart.vue'
import ProgressTable from "@/components/score/ProgressTable.vue";

const props = defineProps({
  currentStep: {
    type: Number,
    default: 0
  },
  scores: {
    type: Object,
    required: true
  },
  isView: {
    type: Boolean,
    default: false
  }
})

const tabs = [
  { name: '整体' },
  { name: '背景与问题' },
  { name: '方案与实施' },
  { name: '技术效果' }
]

const activeTab = ref(0)

// 检查是否有评分数据
const hasScores = computed(() => {
  console.log('Scores object:', JSON.stringify(props.scores, null, 2))

  const isValid = Boolean(
      props.scores?.overall?.dimensions?.length > 0 &&
      props.scores?.overall?.scores?.length > 0 &&
      props.scores?.overall?.max_scores?.length > 0 &&
      props.scores?.background?.dimensions?.length > 0 &&
      props.scores?.background?.scores?.length > 0 &&
      props.scores?.background?.max_scores?.length > 0 &&
      props.scores?.solution?.dimensions?.length > 0 &&
      props.scores?.solution?.scores?.length > 0 &&
      props.scores?.solution?.max_scores?.length > 0 &&
      props.scores?.effect?.dimensions?.length > 0 &&
      props.scores?.effect?.scores?.length > 0 &&
      props.scores?.effect?.max_scores?.length > 0
  )

  console.log('Is valid:', isValid)
  return isValid
})
</script>

<style scoped lang="scss">
.score-section {

}

.tabs {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #E4E4E4;
  gap: 8px;
}

.tab {
  flex: 1;
  position: relative;
  height: 40px;
  line-height: 40px;
  color: #555;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  // &:nth-child(2),
  // &:nth-child(3) {
  //   flex: 1;
  // }
  &:hover {
    color: var(--el-color-primary);
  }
}

.tab.active {
  color: #222;
  font-weight: 600;

  &::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: var(--el-color-primary);
    transition: all 0.3s ease;
  }
}

.tab-content {
  padding-top: 16px;
  line-height: 20px;
  color: #555;
  border-radius: 0 0 12px 12px;
  min-height: 300px;
  > div {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 200px;
  color: var(--el-text-color-secondary);
  gap: 12px;

  .loading-icon {
    font-size: 24px;
    animation: rotating 2s linear infinite;
  }
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
